<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内容管理</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/article' }"
        >文章管理</el-breadcrumb-item
      >
      <el-breadcrumb-item>发布</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card">
      <div class="showtop">
        <div>基本信息</div>
        <div @click="back()" class="back">返回列表</div>
      </div>

      <el-form
        :model="showForm"
        :rules="showRules"
        ref="showFormRef"
        label-width="100px"
        v-loading="loading"
        element-loading-text="正在上传中"
        element-loading-spinner="el-icon-loading"
      >
        <div class="showForm">
          <el-form-item label="栏目" prop="ColumnID">
            <el-select
              v-model="showForm.ColumnID"
              placeholder="请选择栏目"
              clearable
            >
              <el-option
                v-for="item in columnOptions"
                :key="item.ColumnID"
                :label="item.ColumnName"
                :value="item.ColumnID"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标题" prop="Title">
            <el-input v-model="showForm.Title"></el-input>
          </el-form-item>
          <el-form-item label="摘要">
            <el-input type="textarea" v-model="showForm.Abstract"></el-input>
          </el-form-item>
          <el-form-item label="内容" prop="Substance">
            <div style="border: 1px solid #ccc;">
                <Toolbar
                    style="border-bottom: 1px solid #ccc"
                    :editor="editor"
                    :defaultConfig="toolbarConfig"
                    :mode="mode"
                />
                <Editor
                    style="height: 500px; overflow-y: hidden;"
                    v-model="showForm.Substance"
                    :defaultConfig="editorConfig"
                    :mode="mode"
                    @onCreated="onCreated"
                />
            </div>
          </el-form-item>
          <el-form-item label="附件">
            <el-upload
              ref="upload"
              class="upload-demo"
              action="urlApi"
              :on-change="handleChange"
              :headers='headers'
              :on-remove="removeFile"
              :auto-upload="false"
              accept='.pdf,.doc,.docx,.xlsx,.mp4'
              :file-list="fileList">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传.pdf,.doc,.docx,.xlsx,.mp4文件,文件大小100M以下</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="更新时间">
            <el-date-picker
              v-model="showForm.ReleaseTime"
              type="datetime"
              placeholder="选择日期(默认当前时间)"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addCreate()">保存</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
export default {
  components: {
    Editor, Toolbar
  },
  data() {
    return {
      fileList: [],
      // 栏目下拉选项
      columnOptions: [
        {
          value: '1',
          label: '重要通知'
        },
        {
          value: '2',
          label: '大赛新闻'
        },
        {
          value: '3',
          label: '成查转化'
        },
        {
          value: '4',
          label: '资料下载'
        },
        {
          value: '5',
          label: '往届赛事'
        }
      ],
      // 图片上传接口地址
      urlApi:
        process.env.VUE_APP_BASE_URL +
        '/api/ArticleManagementFile/ArticleUploadPicture',
      headers: { Authorization: 'Bearer ' },
      // 添加表单
      showForm: {
        ArticleManagementID: 0,
        ColumnID: '',
        Title: '',
        Abstract: '',
        Substance: '',
        Annex: '',
        ReleaseTime: new Date()
      },
      editor: null,
      html: '',
      toolbarConfig: { },
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            customUpload: this.beforeUploadImg
          },
          uploadVideo: {
            customUpload: this.beforeUploadVideo
          }
        }
      },
      mode: 'default',
      // 添加表单验证
      showRules: {
        ColumnID: [
          {
            required: true,
            message: '请选择文章分类',
            trigger: 'change'
          }
        ],
        Title: [
          {
            required: true,
            message: '请输入文章标题',
            trigger: 'blur'
          }
        ],
        Substance: [
          {
            required: true,
            message: '请输入文章内容',
            trigger: 'blur'
          }
        ]
      },
      // 加载状态
      loading: false,
      uploadImgList: []
    }
  },
  created() {
    this.getToken()
    // 区取所有栏目
    this.getColumn()
  },
  mounted() {
  },
  methods: {
    // 创建编辑器
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    // 附件上传
    handleChange(file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error('请上传100M以下的文件')
        fileList.pop()
        return false
      }
      this.fileList = fileList
    },
    // 附件删除
    removeFile() {
      console.log('附件删除')
    },
    // 添加
    addCreate() {
      this.$refs.showFormRef.validate(async (valid) => {
        // 验证不通过跳出
        if (!valid) return false
        // 判断摘要是否为空,如为空自动截取内容80个字作为摘要
        if (this.showForm.Abstract === '') {
          const str =
            this.getText(this.showForm.Substance).substring(0, 80) + '...'
          this.showForm.Abstract = str
        }
        const formData = new FormData()
        this.fileList.map((file) => {
          formData.append('file', file.raw)
        })
        this.showForm.ReleaseTime = this.$moment(this.showForm.ReleaseTime).format('YYYY-MM-DD HH:mm:ss')
        formData.append('ArticleManagementID', this.showForm.ArticleManagementID)
        formData.append('ColumnID', this.showForm.ColumnID)
        formData.append('Title', this.showForm.Title)
        formData.append('Substance', this.showForm.Substance)
        formData.append('Abstract', this.showForm.Abstract)
        formData.append('ReleaseTime', this.showForm.ReleaseTime)
        // 发起添加请求
        const { data: res } = await this.$http.post(
          '/api/ArticleManagement/AddArticleManagement',
          formData
        )
        // 判断状态码
        if (res.StatusCode !== 1) return this.$message.error(res.Msg)
        // // 成功提示
        this.$message.success(res.Msg)
        this.article()
      })
    },
    getText(str) {
      return str.replace(/<[^<>]+>/g, '').replace(/&nbsp;/gi, '')
    },
    // 跳转到发布页面
    show() {
      this.$router.push('show')
    },
    // 跳转到文章列表
    article() {
      this.$router.push('article')
    },
    // 返回
    back() {
      this.$router.go(-1)
    },
    // 上传状态
    uploadProcess(event, file, fileList) {
      this.loading = true
    },
    // 上传图片
    beforeUploadImg(file, insertFn) {
      var fileSize = file.size / 1024 / 1024 < 2
      if (
        [
          'image/jpeg',
          'image/jpg',
          'image/gif',
          'image/bmp',
          'image/png'
        ].indexOf(file.type) === -1
      ) {
        this.$message.error('上传图片只能是 JPG、JPEG、gif、bmp、PNG 格式!')
        return false
      }
      if (!fileSize) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
      // 上传图片
      const imgData = new FormData()
      imgData.append('file', file)
      this.$http.post(
        this.urlApi, imgData
      ).then(res => {
        insertFn(res.data.Data.articleManagementFiles[0].ServerUrl + res.data.Data.articleManagementFiles[0].FileName)
        console.log(res.data.Data.articleManagementFiles[0])
      })
    },
    // 上传视频
    beforeUploadVideo(file, insertFn) {
      const index = file.name.lastIndexOf('.')
      const FileExt = file.name.substr(index + 1)
      console.log(FileExt)
      const flag = ['mp4'].includes(
        FileExt
      )
      var fileSize = file.size / 1024 / 1024 < 30
      if (!flag) {
        this.$message.error('上传文件只能是 mp4 格式!')
        return false
      }
      if (!fileSize) {
        this.$message.error('上传文件大小不能超过 30MB!')
        return false
      }
      const imgData = new FormData()
      imgData.append('file', file)
      this.$http.post(
        this.urlApi, imgData
      ).then(res => {
        insertFn(res.data.Data.articleManagementFiles[0].ServerUrl + res.data.Data.articleManagementFiles[0].FileName)
        console.log(res.data.Data.articleManagementFiles[0])
      })
    },
    // 上传前回调
    beforeUploadFile(file) {
      const index = file.name.lastIndexOf('.')
      const FileExt = file.name.substr(index + 1)
      console.log(FileExt)
      const flag = ['doc', 'docx', 'xls', 'xlsx', 'pdf', 'zip'].includes(
        FileExt
      )
      var fileSize = file.size / 1024 / 1024 < 30
      if (!flag) {
        this.$message.error('上传文件只能是 doc,docx,xls,xlsx,pdf,zip 格式!')
        return false
      }
      if (!fileSize) {
        this.$message.error('上传文件大小不能超过 30MB!')
        return false
      }
      return true
    },
    getToken() {
      this.headers.Authorization = window.localStorage.getItem('token')
    },
    // 获取所有栏目
    async getColumn() {
      const { data: res } = await this.$http.get(
        '/api/ColumnInfo/GetColumnInfos'
      )
      this.columnOptions = res.Data.columnInfos
      if (res.StatusCode !== 1) return console.log(res.Msg)
    }
  }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>
.showtop {
  display: flex;
  justify-content: space-between;
  color: #666;
  .back {
    cursor: pointer;
  }
}
.showForm {
  margin-top: 30px;
}
.editorz {
  .ql-snow {
    height: 200px;
  }
}
.upload-img {
  position: absolute;
}
.upload-file {
  position: absolute;
}
</style>
